import { makeObservable } from 'mobx';
import uniq from 'lodash/uniq';

import { EntryTypeSpecialtyData } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';

export class EntryTypeSpecialtyList extends List<EntryTypeSpecialtyData, EntryTypeSpecialtyData> {
    constructor(params?: EntryTypeSpecialtyData[]) {
        super(params);
        makeObservable(this);
    }

    public getBySpecialtyId(specialtyId: string): EntryTypeSpecialtyData[] {
        return this.values.filter(it => it.specialtyId === specialtyId);
    }

    public getByEntryTypeIds(): string[] {
        return uniq(this.values.map(it => it.entryTypeId));
    }

    protected create(params: EntryTypeSpecialtyData): EntryTypeSpecialtyData {
        return params;
    }
}

export const entryTypeSpecialityList = new EntryTypeSpecialtyList();
